/*jshint maxparams: 40 */
import bootLayout from 'static/script/app/boot/boot-layout';
import BiddingModal from 'static/script/app/ui/view-item/bidding-modal';
import DetailsListUI from 'static/script/app/ui/view-item/details-list-ui';
import AddToCartButtonUI from 'static/script/app/ui/view-item/add-to-cart-button-ui';
import WishListUI from 'static/script/app/ui/view-item/wish-list-ui';
import ImageGalleryUI from 'static/script/app/ui/view-item/image-gallery';
import ImageZoomUI from 'static/script/app/ui/view-item/image-zoom';
import SimilarItemsUI from 'static/script/app/ui/view-item/similar-items';
import SimilarItemsFromShopUI from 'static/script/app/ui/view-item/similar-items-from-shop';
import FavouriteSellersUI from 'static/script/app/ui/view-item/favourite-sellers-ui';
import FavouriteSellersService from 'static/script/app/data/favourite-sellers-service';
import BiddingEvents from 'static/script/app/data/bidding-events';
import CartService from 'static/script/app/data/cart-service';
import WishListService from 'static/script/app/data/wish-list-service';
import StoreAsRecentlyViewedItem from 'static/script/app/ui/view-item/store-as-recently-viewed-item';
import Toggle from 'static/script/app/ui/toggle';
import BidNotifierData from 'static/script/app/data/bid-notifier';
import CountdownUI from 'static/script/app/ui/view-item/countdown-ui';
import BidNotifier from 'static/script/app/ui/view-item/bid-notifier';
import BiddingForm from 'static/script/app/ui/view-item/bidding-form';
import PrefilledInput from 'static/script/app/ui/prefilled-input';
import WishListUIList from 'static/script/app/ui/wish-list-ui-for-list';
import ItemCardsUI from 'static/script/app/ui/item-cards-ui';
import ItemsInViewportService from 'static/script/app/data/items-in-viewport-service';
import ItemsInViewportUI from 'static/script/app/ui/items-in-viewport-ui';
import searchIdStorage from 'static/script/app/data/searchid';
import EndItem from 'static/script/app/ui/end-item';
import ServerTimePing from 'static/script/app/data/server-time-from-ping';
import triot from 'triot';
import messageValidation from 'static/script/utils/message-validation';
import ContactSellerButton from 'static/script/app/ui/contact/contact-seller-button';
import contactService from 'static/script/app/data/contact-service';
import breakpoint from 'static/script/utils/breakpoints';
import 'static/output/script/riot-core-tags';
import 'static/script/app/ui/mixin/modal-mixin';

module.exports = initData => {
    bootLayout(initData);

    CartService.attachTo(document);
    WishListService.attachTo(document);
    BiddingModal.attachTo('body');

    BiddingEvents.attachTo(document, {
        initialState: initData.pageSpecificData.biddingState
    });

    DetailsListUI.attachTo('[data-details-list-toggle]');
    ImageZoomUI.attachTo(document.body);
    //Image gallery needs to be attached after zoom if gallery keyboard navigation should be cancelled by image zoom
    ImageGalleryUI.attachTo('.image-gallery');


    AddToCartButtonUI.attachTo('[data-view-item-add-to-cart]', {
        itemId: initData.itemId,
        sellerAlias: initData.sellerAlias,
        fixedPrice: initData.fixedPrice
    });

    WishListUI.attachTo('.wish-list-selector', {
        itemId: initData.itemId
    });

    WishListUIList.attachTo('.card-list', { initData: initData });

    SimilarItemsUI.attachTo('[data-similar-items]');
    SimilarItemsFromShopUI.attachTo('[data-similar-items-from-shop]');

    StoreAsRecentlyViewedItem.attachTo('.view-item', {
        itemId: initData.itemId
    });

    ItemCardsUI.attachTo('.card-list');

    Toggle.attachTo('[data-toggle]');

    CountdownUI.attachTo(document, {
        featureSwitches: initData.featureSwitches
    });

    ServerTimePing.attachTo(document, {
        featureSwitches: initData.featureSwitches
    });

    BidNotifierData.attachTo(document, {
        itemId: initData.itemId,
        buyingEventPusherServerUrl: initData.pageSpecificData.BuyingEventPusherServerUrl,
        buyingEventPusherEnabled: initData.pageSpecificData.BuyingEventPusherEnabled,
        featureSwitches: initData.featureSwitches
    });

    BidNotifier.attachTo('body', { memberId: (initData.memberId || 0) });
    PrefilledInput.attachTo(document);
    BiddingForm.attachTo(document);

    if (initData.featureSwitches && initData.featureSwitches['search-metadata-collection-searchimpression']) {
        ItemsInViewportService.attachTo(document);
        ItemsInViewportUI.attachTo('[data-similar-items]');
    }

    searchIdStorage.remove();
    EndItem.attachTo('[data-end-item]');

    FavouriteSellersService.attachTo(document);
    FavouriteSellersUI.attachTo('[data-favourite-seller-add]');

    let contactSellerService = contactService({
        url: '/messages/contact-seller',
        gaEvent_success: {
            category: 'View item',
            label: 'Contact Seller - message sent',
            action: 'Navigation',
            userTriggered: true
        },
        gaEvent_error: {
            category: 'View item',
            label: 'Contact Seller - message error',
            action: 'Navigation',
            userTriggered: true
        }
    });

    ContactSellerButton.attachTo('[data-contact]', {bus: triot.bus});
    triot.mount('[data-contact-seller-modal]', 'contact-modal', { contactService: contactSellerService, validator: messageValidation, breakpoint: breakpoint });
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/view-item.js